import { localeDate } from "../../../../app/datetimeUtils";
import { scoreReportEssayLink } from "../../../../app/links";
import { PromptScoreEChart } from "./PromptScoreEChart";
import { PromptUsage } from "./promptReportApiSlice";

export function PromptScoreChart(props: {
	className?: string;
	scores: PromptUsage[];
	maxValue: number;
}) {
	const getData = () => {
		const data = props.scores.map((data) => {
			const value = data.totalScore;
			return {
				name:
					data.promptName +
					(data.lastUsedDate ? "\n" + localeDate(data.lastUsedDate) : ""),
				value: value != null ? Number(value) : null,
				link: scoreReportEssayLink(data.essayId),
			};
		});
		return data;
	};

	if (!props.scores || props.scores.length == 0) return "";

	return (
		<div className={props.className ?? ""}>
			<PromptScoreEChart
				data={getData()}
				dataLabel="Most Recent Draft Score"
				maxValue={props.maxValue}
			/>
		</div>
	);
}
